import { Avatar, Grid } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { MprcLink } from "components/MprcLink";
import { useSession } from "providers/SessionProvider";
import { useModalUserProfile } from "providers/UserProfileProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { resolveAuthor } from "views/knowledge/components/card/behaviors/common/DefaultAuthor";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const ThreadAuthor = () => {

    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();
    const location = useLocation();
    const { showUser } = useModalUserProfile();
    const session = useSession();

    var author = resolveAuthor(pub, t, session.user.userId);

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={author.name}>{author.name}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
            {!pub.isAnonymous &&
                <Grid>
                    {pub.institutional != null
                        ? <Avatar src={author.thumbnailUrl} title={author.name} />
                        : <Avatar
                            className={AppGlobalClassKeys.clickable}
                            title={author.name}
                            src={author.thumbnailUrl}
                            onClick={
                                () => showUser(
                                    pub.author.userId,
                                    () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                )
                            }
                        />
                    }
                </Grid>
            }
            <Grid size="grow" overflow="hidden">
                {
                    (pub.institutional != null || pub.isAnonymous)
                        ? RenderAuthorName
                        : (
                            <MprcLink
                                onClick={
                                    () => showUser(
                                        pub.author.userId,
                                        () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                    )
                                }
                            >
                                {RenderAuthorName}
                            </MprcLink>
                        )
                }

                <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                    <span>{author.actionFormatted}</span>
                </MprcFeedTypography>
            </Grid>
        </Grid >
    );
};
